(function initMxpetFilterCompatibility() {
  const brands = new Map([
    ['granatapet', 'GranataPet'],
    ['catzfinefood', 'Catz FineFood'],
    ['luckylou', 'Lucky Lou'],
    ['kittycat', 'Kitty Cat'],
    ['bettys', 'Betty`s Landhausküche'],
    ['bettyslandhauskuche', 'Betty`s Landhausküche']
  ]);
  const scopeKey = query => 'mxpet-brand-cleared:' + query.trim().toLowerCase();
  function cleared(query) {
    try { return sessionStorage.getItem(scopeKey(query)) === '1'; } catch { return true; }
  }
  function rememberClear(query, value) {
    try {
      if (value) sessionStorage.setItem(scopeKey(query), '1');
      else sessionStorage.removeItem(scopeKey(query));
    } catch {}
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const current = new URL(window.location.href);
    const target = new URL(link.href, current);
    const query = current.searchParams.get('q') || '';
    if (query && /\/search\/?$/.test(current.pathname)
      && target.origin === current.origin && target.pathname === current.pathname
      && target.searchParams.get('q') === query
      && current.searchParams.has('filter.p.vendor') && !target.searchParams.has('filter.p.vendor')) {
      rememberClear(query, true);
    }
  }, true);
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.name !== 'filter.p.vendor' || input.checked || !input.form) return;
    if (input.form.querySelector('input[name="filter.p.vendor"]:checked')) return;
    const current = new URL(window.location.href);
    if (/\/search\/?$/.test(current.pathname)) rememberClear(current.searchParams.get('q') || '', true);
  }, true);
  function normalizedUrl(href) {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin || !/\/(?:search|collections\/[^/]+)\/?$/.test(url.pathname)) return url;
    const params = url.searchParams;
    const legacy = 'filter.v.option.net weight';
    const current = 'filter.p.m.custom.net_weight_filter';
    if (params.has(legacy)) {
      const values = new Set([...params.getAll(current), ...params.getAll(legacy)].flatMap(value => value.split(',')).filter(Boolean));
      params.delete(legacy);
      params.delete(current);
      values.forEach(value => params.append(current, value));
      params.delete('page');
    }
    if (/\/search\/?$/.test(url.pathname) && !params.has('filter.p.vendor') && !cleared(params.get('q') || '')) {
      const key = (params.get('q') || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[\s’'`]/g, '');
      const brand = brands.get(key);
      if (brand) {
        params.set('filter.p.vendor', brand);
        params.delete('page');
      }
    }
    return url;
  }
  const original = new URL(window.location.href);
  const next = normalizedUrl(original.href);
  if (next.href !== original.href) window.location.replace(next.href);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get' || form.getAttribute('role') !== 'search') return;
    const target = new URL(form.action, window.location.origin);
    if (!/\/search\/?$/.test(target.pathname) || target.origin !== window.location.origin) return;
    target.search = new URLSearchParams(new FormData(form)).toString();
    rememberClear(target.searchParams.get('q') || '', false);
    const normalized = normalizedUrl(target.href);
    if (normalized.href === target.href) return;
    event.preventDefault();
    window.location.assign(normalized.href);
  }, true);
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-nav-dropdown]').forEach((item) => {
    const button = item.querySelector('[data-nav-dropdown-toggle]');
    const label = item.querySelector('.site-header__nav-link')?.textContent?.trim() || 'catalog';
    if (!button) return;

    function setDropdown(open) {
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', `${open ? 'Close' : 'Open'} ${label} menu`);
    }

    function closeOtherDropdowns() {
      item.parentElement?.querySelectorAll('[data-nav-dropdown].is-open').forEach((other) => {
        if (other === item) return;
        other.classList.remove('is-open');
        const otherButton = other.querySelector('[data-nav-dropdown-toggle]');
        const otherLabel = other.querySelector('.site-header__nav-link')?.textContent?.trim() || 'catalog';
        otherButton?.setAttribute('aria-expanded', 'false');
        otherButton?.setAttribute('aria-label', `Open ${otherLabel} menu`);
      });
    }

    item.addEventListener('pointerenter', () => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        closeOtherDropdowns();
      }
    });

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const willOpen = !item.classList.contains('is-open');
      closeOtherDropdowns();
      setDropdown(willOpen);
    });

    document.addEventListener('click', (event) => {
      if (!item.contains(event.target)) setDropdown(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
      setDropdown(false);
      button.focus();
    });
  });

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach((button) => {
    const header = button.closest('[data-site-header]');
    const menu = header?.querySelector('#MxpetMobileMenu');

    function setMenu(open) {
      if (!header) return;
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      header.classList.toggle('menu-open', open);
    }

    button.addEventListener('click', () => {
      if (!header) return;
      const expanded = button.getAttribute('aria-expanded') === 'true';
      setMenu(!expanded);
    });

    menu?.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenu(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || button.getAttribute('aria-expanded') !== 'true') return;
      setMenu(false);
      button.focus();
    });

    document.addEventListener('click', (event) => {
      if (button.getAttribute('aria-expanded') !== 'true' || header.contains(event.target)) return;
      setMenu(false);
    });
  });
});

/* Product descriptions imported from the source catalogue use lightweight
   .gp-toggle/.gp-content disclosures. Shopify strips scripts from product
   descriptions, so the interaction belongs in the theme and must also keep
   working when the theme editor replaces a section without reloading. */
(function initMxpetProductDescriptionAccordions() {
  const toggleSelector = '.product-short-description .gp-toggle[data-target]';

  function findPanel(toggle) {
    const description = toggle.closest('.product-short-description');
    const target = toggle.getAttribute('data-target');

    if (!description || !target) return null;

    const safeTarget = window.CSS && CSS.escape
      ? CSS.escape(target)
      : target.replace(/[^a-zA-Z0-9_-]/g, '\\$&');

    return description.querySelector(`#${safeTarget}`)
      || description.querySelector(`[data-section="${safeTarget}"]`)
      || (toggle.nextElementSibling?.classList.contains('gp-content')
        ? toggle.nextElementSibling
        : null);
  }

  function prepareToggle(toggle) {
    const panel = findPanel(toggle);
    if (!panel) return;

    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    if (panel.id) toggle.setAttribute('aria-controls', panel.id);

    const isOpen = toggle.classList.contains('active')
      || toggle.getAttribute('aria-expanded') === 'true'
      || (panel.style.display && panel.style.display !== 'none');

    toggle.classList.toggle('active', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));
    panel.hidden = !isOpen;
    panel.style.display = isOpen ? 'block' : 'none';
  }

  function prepareAll(root = document) {
    root.querySelectorAll?.(toggleSelector).forEach(prepareToggle);
  }

  function togglePanel(toggle) {
    const panel = findPanel(toggle);
    if (!panel) return;

    const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.classList.toggle('active', willOpen);
    toggle.setAttribute('aria-expanded', String(willOpen));
    panel.hidden = !willOpen;
    panel.style.display = willOpen ? 'block' : 'none';
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest?.(toggleSelector);
    if (!toggle) return;

    event.preventDefault();
    togglePanel(toggle);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const toggle = event.target.closest?.(toggleSelector);
    if (!toggle) return;

    event.preventDefault();
    togglePanel(toggle);


  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareAll(), { once: true });
  } else {
    prepareAll();
  }

  document.addEventListener('shopify:section:load', (event) => prepareAll(event.target));
})();


/* Give life-stage and dietary-need landing pages a focused header. */
(function initMxpetNeedFilterContext() {
  const labels = {
    Adult: 'Adult',
    'Kitten & Junior': 'Kitten & Junior',
    Senior: 'Senior',
    Sterilized: 'Sterilized',
    'Puppy & Junior': 'Puppy & Junior',
    Monoprotein: 'Monoprotein',
    Sensitive: 'Sensitive'
  };

  function prepare(root = document) {
    const header = root.querySelector?.('.template-header--all')
      || document.querySelector('.template-header--all');
    if (!header) return;
    if (!header.mxpetOriginalContent) {
      header.mxpetOriginalContent = header.innerHTML;
    }

    const params = new URLSearchParams(window.location.search);
    const selectedNeeds = [...params.getAll('filter.p.m.custom.life_stage'),
      ...params.getAll('filter.p.m.custom.dietary_need')];
    const label = [...new Set(selectedNeeds.map(value => labels[value]).filter(Boolean))].join(' + ');
    if (!label) {
      if (header.classList.contains('template-header--need-filtered')) {
        header.innerHTML = header.mxpetOriginalContent;
        header.classList.remove('template-header--need-filtered');
      }
      return;
    }

    const selectedTypes = params.getAll('filter.p.product_type');
    const productType = (selectedTypes.length > 1 ? 'All pets' : selectedTypes[0])
      || (window.location.pathname.endsWith('/cat-wet-food') ? 'Cat wet food'
        : window.location.pathname.endsWith('/dog-wet-food') ? 'Dog wet food' : '');
    const pet = productType.startsWith('Cat')
      ? 'cat wet food'
      : productType.startsWith('Dog')
        ? 'dog wet food'
        : 'wet food';

    header.classList.add('template-header--need-filtered');

    const eyebrow = header.querySelector('.mxpet-collection-brand-copy > .mxpet-collection-eyebrow');
    const title = header.querySelector('.template-header--title');
    const description = header.querySelector('.collection-banner--description .max-height--inner-content')
      || header.querySelector('.collection-banner--description');

    if (eyebrow) eyebrow.textContent = 'Shop by need';
    if (title) title.textContent = `${label} ${pet}`;
    if (description) {
      description.textContent = `Explore ${label.toLowerCase()} ${pet}, then use the filters below to refine your choice.`;
    }

    if (!header.querySelector('.mxpet-filter-context__back')) {
      const back = document.createElement('a');
      back.className = 'mxpet-filter-context__back';
      back.href = '/collections/all#shop-by-need';
      back.textContent = 'Browse all needs';
      (description?.closest('.collection-banner--description') || description || title)?.after(back);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  } else {
    prepare();
  }

document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  document.addEventListener('facets:updated', () => prepare());
})();

/* Keep Shop by need focused on the selected pet type. */
(function initMxpetNeedPetContext() {
  function prepare(root = document) {
    const guide = root.querySelector?.('.mxpet-needs-guide')
      || document.querySelector('.mxpet-needs-guide');
    if (!guide) return;

    const productType = new URLSearchParams(window.location.search)
      .get('filter.p.product_type') || '';
    const pet = productType.toLowerCase().startsWith('cat')
      ? 'cat'
      : productType.toLowerCase().startsWith('dog')
        ? 'dog'
        : '';

    guide.querySelectorAll('[data-mxpet-need-group]').forEach((group) => {
      group.hidden = Boolean(pet) && group.dataset.mxpetNeedGroup !== pet;
    });

    guide.querySelectorAll('[data-mxpet-need-pet]').forEach((link) => {
      const isCurrent = Boolean(pet) && link.dataset.mxpetNeedPet === pet;
      if (isCurrent) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });

    if (pet) guide.dataset.mxpetPetView = pet;
    else delete guide.dataset.mxpetPetView;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  } else {
    prepare();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();


/* Route primary Cat/Dog shop entries to the dedicated collection pages. */
(function () {
  const routes = {
    '/collections/all?filter.p.product_type=Cat%20wet%20food': '/collections/cat-wet-food',
    '/collections/all?filter.p.product_type=Dog%20wet%20food': '/collections/dog-wet-food'
  };

  const updatePrimaryPetLinks = () => {
    document.querySelectorAll('header.site-header a[href], .site-footer__grid a[href]').forEach((link) => {
      const current = link.getAttribute('href');
      if (routes[current]) link.setAttribute('href', routes[current]);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePrimaryPetLinks, { once: true });
  } else {
    updatePrimaryPetLinks();
  }
  document.addEventListener('shopify:section:load', updatePrimaryPetLinks);
})();
/* Make the keyword scope explicit without silently discarding the query. */
(function initMxpetSearchScope() {
  function prepare() {
    const form = document.querySelector('.template-header form[role="search"]');
    if (!form) return;
    const query = new URLSearchParams(window.location.search).get('q')?.trim();
    if (!query) return;
    let scope = document.getElementById('MxpetSearchScope');
    if (!scope) {
      scope = document.createElement('p');
      scope.id = 'MxpetSearchScope';
      form.closest('.template-header').querySelector('.template-header--description')?.after(scope);
    }
    const params = new URLSearchParams(window.location.search);
    const filters = new URLSearchParams();
    params.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'sort_by') filters.append(key, value);
    });
    if (filters.get('sort_by') === 'relevance') filters.delete('sort_by');
    const link = document.createElement('a');
    link.href = '/collections/all' + (filters.size ? '?' + filters.toString() : '');
    link.textContent = 'Browse all products with these filters';
    scope.replaceChildren(document.createTextNode('Filters apply only to search results for “' + query + '”. '), link);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
  document.addEventListener('facets:updated', prepare);
})();

